import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatSelectSearchComponent } from './mat-select-search.component';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ MatSelectSearchComponent ],
  exports: [ MatSelectSearchComponent ],
  imports: [ CommonModule, 
    ReactiveFormsModule,
    MatSelectModule,
    MatToolbarModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    NgxMatSelectSearchModule ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class MatSelectSearchModule {}